<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1080 1080"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <circle
      style="fill-rule: evenodd; clip-rule: evenodd; fill: currentColor;"
      cx="539.6"
      cy="539.6"
      r="539.6"
    />
    <path
      style="fill-rule: evenodd; clip-rule: evenodd; fill: white;"
      d="M743.7,678.1c8.6,8.6,13.5,20.3,13.5,32.5s-4.8,23.8-13.5,32.4l-0.7,0.7
	c-8.6,8.6-20.3,13.5-32.4,13.5c-12.2,0-23.8-4.8-32.5-13.5L539.6,605.1L401,743.7c-8.6,8.6-20.3,13.5-32.4,13.5
	c-12.2,0-23.8-4.8-32.5-13.5c-0.2-0.2-0.4-0.4-0.7-0.7c-8.6-8.6-13.4-20.3-13.4-32.4s4.8-23.8,13.4-32.5L474,539.6L335.5,401
	c-8.6-8.6-13.4-20.3-13.4-32.4c0-12.2,4.8-23.8,13.4-32.5l0.7-0.7c8.6-8.6,20.3-13.4,32.5-13.4c12.2,0,23.8,4.8,32.4,13.4L539.6,474
	l138.5-138.5c8.6-8.6,20.3-13.4,32.5-13.4c12.2,0,23.8,4.8,32.4,13.4c0.2,0.2,0.4,0.4,0.7,0.7c8.6,8.6,13.5,20.3,13.5,32.5
	c0,12.2-4.8,23.8-13.5,32.4L605.1,539.6L743.7,678.1z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconRejected"
};
</script>
